import { render, staticRenderFns } from "./FaskesCategory.vue?vue&type=template&id=9537245e"
import script from "./FaskesCategory.vue?vue&type=script&lang=js"
export * from "./FaskesCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports